import { ICON__maximize } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_instanceof, assert_true } from '@shared/asserts/utils_asserts';
import { DTO__image_crop_box } from '@shared/dto/+image/image_asset_base/DTO__image_crop_box';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';
import { INVOCATION_IMAGE__viewport } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__viewport';

export function G_BUTTON__image_crop_box_maximize() {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_image_edit__field: field } = use_slice_ui(['g_image_edit__field']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  let { graph } = generation_current.tool;

  /*
   * EVENTS
   */

  async function onClick() {
    let node = graph.node__get(field.meta.node_id);
    assert_instanceof(node, INVOCATION_IMAGE__viewport);

    let graph_new = graph.clone();

    node.cropbox_maximize(graph_new);

    await UTILS__graph_data.update(graph_new);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    let node = graph.node__get(field.meta.node_id);
    assert_instanceof(node, INVOCATION_IMAGE__viewport);

    assert_true(field.image__is_initialized);

    let crop_box = DTO__image_crop_box.create_first_crop_box_for_image(field.get_image_size(), node.crop_box.target_aspect_ratio);
    if (crop_box.is_equals(node.crop_box.crop_box)) return true; //already maximized

    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (field.is_stub()) return <PLACEHOLDER_bar_line />;
  if (!field.get_has_content()) return <PLACEHOLDER_bar_line />;
  if (field.meta.node_type != ENUM__invocation_type.IMAGE__VIEWPORT) return <PLACEHOLDER_bar_line />;
  if (!field.image__is_initialized) return <PLACEHOLDER_bar_line />;

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} variant={'outline-on-bar'} size={'w-full-h-10'} {...{ onClick }}>
      <ICON__maximize className="!size-3 text-bar-foreground" />
      Maximize Crop Box
    </UI_PRIMITIVE__button>
  );
}
